import React from "react";
import "./SkillsCovered.css";
import AchieveIcn from "../assets/images/achieve-icn.png";
import PraIcn from "../assets/images/pra-icn.png";
import PraIcn02 from "../assets/images/pra-icn02.png";
import PraIcn03 from "../assets/images/pra-icn03.png";
import PraIcn04 from "../assets/images/pra-icn04.png";

const SkillsCovered = () => {
  const skills = [
    {
      icon: <img src={PraIcn02} alt="pra-icn" />,
      title: "Community-Driven",
      description: "Get personalized guidance, doubt resolution, and career clarity from experts."
    }, 
    {
      icon: <img src={PraIcn03} alt="pra-icn" />,
      title: "Industry Mentors",
      description: "Build a robust portfolio by applying your knowledge to industry-relevant."
    },       
    {
      icon: <img src={PraIcn} alt="pra-icn" />,
      title: "Practical Skill Building",
      description: "Get personalized guidance, doubt resolution, and career clarity from experts."
    },
    {
      icon: <img src={PraIcn04} alt="pra-icn" />,
      title: "Real-World Project Focus",
      description: "Gain invaluable insights and personalized career advice from leaders."
    }
  ];

  return (
    <div className="skills-main-section">
      <div className="skills-covered-container">
        <div className="skills-content-bar">
         <div className="skills-left">
          <div className="achieve-icn"><img src={AchieveIcn} className="achieveicn" /></div>
          <div className="skills-achieve-text">What you will achieve ?</div>
          <div className="skills-covered-title">Skills Cover</div> 
          <p>Explore what makes RoboAI the ultimate <br/>choice for robotics enthusiasts</p>
         </div>
         <div className="skills-right">
          <div className="skills-slider-wrapper">
            <div className="skills-marquee-track">
              {/* First Set */}
              {skills.map((skill, index) => (
                <div key={`set1-${index}`} className="skill-card">
                  <div className="skill-icon">{skill.icon}</div>
                  <h3 className="skill-title">{skill.title}</h3>
                  <p className="skill-description">{skill.description}</p>
                </div>
              ))}
              {/* Second Set - Duplicate for seamless loop */}
              {skills.map((skill, index) => (
                <div key={`set2-${index}`} className="skill-card">
                  <div className="skill-icon">{skill.icon}</div>
                  <h3 className="skill-title">{skill.title}</h3>
                  <p className="skill-description">{skill.description}</p>
                </div>
              ))}
            </div>
          </div>
         </div>
        </div>
      </div>
    </div>
  );
};

export default SkillsCovered;